import * as React from "react";
import { JSX } from "react/jsx-runtime";
const TurnoverIcon = ({
  color = "#fff",
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3798_109007)">
      <path
        d="M13.1996 13.1949L9.99958 9.99491M9.99958 9.99491L6.79958 13.1949M9.99958 9.99491V17.1949M16.7116 15.1069C17.4918 14.6815 18.1082 14.0084 18.4635 13.1938C18.8187 12.3792 18.8925 11.4695 18.6733 10.6083C18.4541 9.74703 17.9544 8.98332 17.2529 8.43767C16.5515 7.89201 15.6883 7.5955 14.7996 7.59491H13.7916C13.5494 6.6583 13.0981 5.78878 12.4715 5.0517C11.845 4.31463 11.0595 3.72919 10.1741 3.33939C9.28866 2.9496 8.32642 2.7656 7.35967 2.80121C6.39292 2.83683 5.44683 3.09115 4.59252 3.54504C3.73821 3.99893 2.99791 4.64059 2.42728 5.42177C1.85664 6.20296 1.47053 7.10334 1.29796 8.05522C1.12539 9.00711 1.17086 9.98573 1.43095 10.9175C1.69103 11.8493 2.15897 12.71 2.79958 13.4349"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3798_109007">
        <rect
          width="19.2"
          height="19.2"
          fill={color}
          transform="translate(0.398438 0.398438)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default TurnoverIcon;
